import { IComponentOptions, IController } from 'angular';
import { StorageService } from '../../../../core/providers/storage/storage.service';
import { $Event } from '../../../../helpers';
import { IMenuItem } from '../../menu.items';
import { StateService } from '@uirouter/angularjs';
import { User } from '../../../../core/entities/user';
import './dashboard-sidebar.component.scss';
import { ModalService } from '../../../../components/modals/gmc-modal/gmc-modal.service';
import { IAdditionalInfoModalData } from '../../../../components/modals/additional-info-modal/additional-info-modal-data.interface';
import { IBalance } from '../../../../core/services/payment/payment.service';
import { DashboardService } from '../../dashboard.service';
import { dashboardStateName } from '../../dashboard-routing';
import { AuthService } from '../../../../core/services/auth/auth.service';

const sbStateName = 'app.dashboard.small-business';

class DashboardSidebarMobileController implements IController {
  static $inject = [
    'StorageService',
    '$state',
    'ModalService',
    'DashboardService',
    'AuthService'
  ];
  user: User;
  isCandidate: boolean;
  balance: IBalance;
  isOpened: boolean;
  items: IMenuItem[];
  logoPath = '/assets/images/GMC_logo_big.png';
  onToggle: ($event: any) => void;
  sbMenuItems: IMenuItem[];
  isSbVisible: boolean = false;
  screenWidth: string;

  constructor(
    private storageService: StorageService,
    private $state: StateService,
    private modalService: ModalService,
    private dashboardService: DashboardService,
    private authService: AuthService
  ) {
    this.isCandidate = this.authService.userRoles.isCandidate;
  }

  $onInit() {
    this.dashboardService.onShowSbMenu().subscribe((isSbVisible) => {
      this.isSbVisible = isSbVisible;
    });
    this.checkMobilSideBar();
    this.findCurrentMenuItem();
    this.initData();
  }

  toggleSidebar() {
    console.log(this.isOpened);
    this.isOpened = !this.isOpened;
    this.storageService.put('isSidebarOpened', this.isOpened);
    this.onToggle(new $Event({ isOpened: this.isOpened }));
    this.transitionButton();
  }

  transitionButton() {
    if (this.isOpened) {
      this.screenWidth = window.innerWidth - 80 + 'px';
    } else {
      this.screenWidth = 100 + '%';
    }
  }

  closeSideBar() {
    if (this.isOpened) {
      this.isOpened = false;
      this.storageService.put('isSidebarOpened', this.isOpened);
      this.onToggle(new $Event({ isOpened: this.isOpened }));
      this.transitionButton();
    } else {
      return;
    }
  }

  showInfoModal(title: string = '', sum: string = '') {
    const text = `${title} platform will be launched when the number of people registered with GMC will exceed ${sum}`;
    const data: IAdditionalInfoModalData = {
      text: text,
      acceptBtnText: 'OK'
    };
    this.modalService.showModal({
      component: 'additionalInfoModal',
      backdrop: true,
      data,
      extraClasses: 'modal-dialog-centered-1'
    });
  }


  checkMobilSideBar() {
    let screen = document.body.clientWidth;
    if (screen < 767) {
      this.isOpened = false;
      this.storageService.put('isSidebarOpened', this.isOpened);
      this.onToggle(new $Event({ isOpened: this.isOpened }));
    } else {
      this.isOpened = this.storageService.get('isSidebarOpened');
    }
  }

  private findCurrentMenuItem() {
    for (const item of this.items) {
      if (this.$state.includes(item.sref)) {
        item.isOpened = true;
        break;
      }
    }
  }

  private initData() {
    this.sbMenuItems = [
      {
        title: 'Dashboard',
        icon: 'my-profile-dashboard-item',
        sref: `${sbStateName}.dashboard`
      },
      {
        title: 'Business Guide',
        icon: 'my-profile-profit-item',
        sref: `${sbStateName}.business-guide`
      },
      {
        title: 'Project Promotion',
        icon: 'my-profile-project-item',
        sref: `${sbStateName}.project-promotion.general-info`
      },
      {
        title: 'Promo Materials',
        icon: 'my-profile-promo-item',
        sref: `${sbStateName}.promo-materials`
      },
      {
        title: this.isCandidate ? 'Business Status' : 'Candidate Database',
        icon: 'my-profile-business-item',
        extraClass: 'gold-item',
        sref: `${sbStateName}.business-status`
      },
      {
        title: 'Global Statistic',
        icon: 'my-profile-global-item',
        sref: `${sbStateName}.global-statistic`
      },
      {
        title: 'My Finance',
        icon: 'my-profile-finance-item',
        sref: `${sbStateName}.finance`
      },
      {
        title: 'Mail Box',
        icon: 'my-profile-mail-item',
        sref: `${sbStateName}.mailbox`
      },
      {
        title: 'F.A.Q.',
        icon: 'my-profile-faq-item',
        sref: `${sbStateName}.faq`
      }
    ];
  }
}

export const DashboardSidebarMobileComponent: IComponentOptions = {
  controller: DashboardSidebarMobileController,
  template: require('./dashboard-sidebar.component.html'),
  bindings: {
    user: '<',
    balance: '<',
    isOpened: '<',
    items: '<',
    getCounter: '<?',
    counter: '<?',
    onToggle: '&'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/dashboard/components/dashboard-sidebar/dashboard-sidebar.component.ts